import apiClient from "./api";

export const createShoutoutOrder = async (orderData) => {
  try {
    const response = await apiClient.post(
      "/shoutouts/create-request-shoutout",
      orderData
    );
    return response.data;
  } catch (error) {
    console.error("Order creation error:", error);
    throw (
      error.response?.data || { message: "Failed to create shoutout order" }
    );
  }
};

export const getUserOrders = async () => {
  try {
    const response = await apiClient.get("/shoutouts/fan-requests");
    return response.data;
  } catch (error) {
    console.error("Fetch orders error:", error);
    throw error.response?.data || { message: "Failed to fetch orders" };
  }
};

export const getOrderById = async (orderId) => {
  try {
    const response = await apiClient.get(`/shoutouts/order/${orderId}`);
    return response.data;
  } catch (error) {
    console.error("Fetch order error:", error);
    throw error.response?.data || { message: "Failed to fetch order" };
  }
};
